/** Shared hero typography (Profile, Services, Service Details, Contact). */
export const motionSafe =
  'opacity-0 motion-reduce:translate-y-0 motion-reduce:opacity-100 motion-reduce:animate-none';

/** Playfair Display: serif, medium, italic — matches Profile page hero headline. */
export const heroTitleClass =
  'font-serif text-xl font-semibold italic leading-snug tracking-wide sm:text-2xl md:text-3xl lg:text-4xl';

/** Gold uppercase subtitle line under the hero title. */
export function heroSubtitleClass(motion = motionSafe) {
  return `mx-auto mt-5 max-w-2xl text-center text-base font-semibold uppercase tracking-[0.2em] text-gold sm:text-lg ${motion} animate-fade-in-up [animation-delay:240ms]`;
}
